import { EnvironmentInterface } from '../environment-interface';

export const environment: EnvironmentInterface = {
  production: true,
  debugRoutes: false,
};
